export const dictionary = {
	en: {
		credentialsTitle: "Email and password",
		registerTitle: "Please create account",
		loginTitle: "Please sign in",
		loginSwitch: "go to login page",
		loginButton: "login",
		registerButton: "register",
		rememberMe: "Remember me",
		forgotPasswordButton: "Forget password?",
		recoverTitle: "Update password",
		ForgotTitle: "Recover password",
		temporaryCode: "Temporary code",
		recoverEmailText: "Retrieve your account by following the instructions that you will receive shortly at the indicated email",
		newPassword: "New password",
		repeatPassword: "Repeat password",
		recoverWord: "Recover",
		memo: "Save",
		oauthSocialLoading: "Signing you in…",
		oauthSocialSuccess: "You are signed in. Your session has been saved.",
		dismissBanner: "Dismiss",
	},
	it: {
		credentialsTitle: "Credenziali",
		registerTitle: "Crea un account",
		loginTitle: "Accedi al tuo account",
		loginSwitch: "vai al login",
		loginButton: "Accedi",
		registerButton: "Registrati",
		rememberMe: "Ricordami",
		forgotPasswordButton: "Password dimenticata?",
		recoverTitle: "Aggiorna la password",
		ForgotTitle: "Recupera la password",
		temporaryCode: "Codice temporaneo",
		recoverEmailText: "Recupera il tuo account seguendo le istruzioni che riceverai a breve presso l'email indicata",
		newPassword: "Nuova password",
		repeatPassword: "Ripeti la password",
		recoverWord: "Recupera",
		memo: "Memorizza",
		oauthSocialLoading: "Accesso in corso…",
		oauthSocialSuccess: "Accesso effettuato. La sessione è stata salvata.",
		dismissBanner: "Chiudi",
	},
};
